import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { misc } from "@/lib/misc";
import {
  HttpResponse,
  MyCandidaciesQueryParams,
  MyCandidacyResponse,
} from "@/types";

export function useGetMyCandidacies(queryOptions: MyCandidaciesQueryParams) {
  return useQuery({
    queryKey: ["my-candidacies", queryOptions],
    queryFn: async () => {
      const queryParams = misc.prepareQueryParams(queryOptions);
      const path = `aviary?${queryParams.toString()}`;
      const res = await guacHttpClient.get<
        MyCandidacyResponse[],
        HttpResponse<MyCandidacyResponse[]>
      >(path);
      return res.data;
    },
    placeholderData: (previousData) => previousData,
  });
}
